import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Controller, useFieldArray, useForm } from "react-hook-form";
import { Col, Row } from "react-bootstrap";
import { FormattedMessage, useIntl } from "react-intl";
import { editSection, getSection } from "store/actions";
import Loader from "components/shared/Loader";
import { useState } from "react";
import SaveChangesButton from "components/shared/SaveChangesButton";
import { toastErrorMessage } from "helpers/toaster/toastErrorMessage";
import ImageUpdate from "./ImageUpdate";

const Overview = () => {
  const { formatMessage, locale } = useIntl();
  const dispatch = useDispatch();
  const { loading, error, section } = useSelector((state) => state.section);
  const [sliders, setSliders] = useState([]);
  const [selectedImage, setSelectedImage] = useState({
    preview: null,
    path: "",
  });
  const {
    register,
    reset,
    handleSubmit,
    formState: { errors },
    control,
  } = useForm();

  const { fields, append, remove } = useFieldArray({
    control,
    name: "statics",
  });

  const {
    fields: fieldsList,
    append: appendList,
    remove: removeList,
  } = useFieldArray({
    control,
    name: "list",
  });

  // get single page by slug
  useEffect(() => {
    dispatch(
      getSection({
        page: "overview",
        slug: "overview",
      })
    );
  }, [dispatch]);

  useEffect(() => {
    reset(section);

    setSliders(section?.sliders);

    setSelectedImage({
      preview: null,
      path: section?.image,
    });
  }, [reset, section]);

  // error
  useEffect(() => {
    if (error) {
      toastErrorMessage(formatMessage({ id: "sendingErrorMessage" }), locale);
    }
  }, [error, formatMessage, locale]);

  const onSubmit = (data) => {
    // if (!selectedImage?.path) {
    //   toastErrorMessage(formatMessage({ id: "imageErrorMessage" }), locale);
    //   return;
    // }

    data.image = `/uploads/${selectedImage?.path?.split("/").pop()}`;
    data.sliders = sliders;
    dispatch(
      editSection({
        slug: "overview",
        page: "overview",
        data: { section: data },
      })
    );
  };

  if (loading) return <Loader />;

  return (
    <>
      <div className="acc-form">
        <div className="card">
          <div className="card-head">
            <h4>
              <FormattedMessage id={"about"} />
            </h4>
          </div>
          <div className="card-body">
            <form onSubmit={handleSubmit(onSubmit)}>
              <Col md={12}>
                <Row>
                  <Col lg={6} xs={12}>
                    <Controller
                      name="firstImage"
                      control={control}
                      rules={{ required: true }}
                      render={({ field: { value, onChange } }) => (
                        <ImageUpdate
                          title="firstImage"
                          value={value}
                          setValue={(value) => onChange(value)}
                        />
                      )}
                    />
                  </Col>
                  <Row />
                  <Col lg={6} xs={12}>
                    <div className="form-group">
                      <h5>
                        <FormattedMessage id="firstHeading" /> ({" "}
                        <FormattedMessage id="arabic-language" /> )
                      </h5>
                      <input
                        type="text"
                        className="form-control form-outline"
                        {...register("firstHeading.ar")}
                      />
                    </div>
                  </Col>
                  <Col lg={6} xs={12}>
                    <div className="form-group">
                      <h5>
                        <FormattedMessage id={"firstHeading"} /> ({" "}
                        <FormattedMessage id={"english-language"} /> )
                      </h5>
                      <input
                        type="text"
                        name="firstHeading.en"
                        className="form-control form-outline"
                        {...register("firstHeading.en")}
                      />
                    </div>
                  </Col>
                  <Col lg={6} xs={12}>
                    <div className="form-group">
                      <h5>
                        <FormattedMessage id={"firstDescription"} /> ({" "}
                        <FormattedMessage id={"arabic-language"} /> )
                      </h5>
                      <textarea
                        type="text"
                        name="firstDescription.ar"
                        className="form-control form-outline"
                        {...register("firstDescription.ar")}
                      />
                    </div>
                  </Col>
                  <Col lg={6} xs={12}>
                    <div className="form-group">
                      <h5>
                        <FormattedMessage id={"firstDescription"} /> ({" "}
                        <FormattedMessage id={"english-language"} /> )
                      </h5>
                      <textarea
                        type="text"
                        name="firstDescription.en"
                        className="form-control form-outline"
                        {...register("firstDescription.en")}
                      />
                    </div>
                  </Col>
                </Row>
                <hr />
                <Row>
                  <Col lg={6} xs={12}>
                    <Controller
                      name="secondImage"
                      control={control}
                      rules={{ required: true }}
                      render={({ field: { value, onChange } }) => (
                        <ImageUpdate
                          title="secondImage"
                          value={value}
                          setValue={(value) => onChange(value)}
                        />
                      )}
                    />
                  </Col>
                  <Row />
                  <Col lg={6} xs={12}>
                    <div className="form-group">
                      <h5>
                        <FormattedMessage id={"secondHeading"} /> ({" "}
                        <FormattedMessage id={"arabic-language"} /> )
                      </h5>
                      <input
                        type="text"
                        name="secondHeading.ar"
                        className="form-control form-outline"
                        {...register("secondHeading.ar")}
                      />
                    </div>
                  </Col>
                  <Col lg={6} xs={12}>
                    <div className="form-group">
                      <h5>
                        <FormattedMessage id={"secondHeading"} /> ({" "}
                        <FormattedMessage id={"english-language"} /> )
                      </h5>
                      <input
                        type="text"
                        name="secondHeading.en"
                        className="form-control form-outline"
                        {...register("secondHeading.en")}
                      />
                    </div>
                  </Col>
                  <Col lg={6} xs={12}>
                    <div className="form-group">
                      <h5>
                        <FormattedMessage id={"secondDescription"} /> ({" "}
                        <FormattedMessage id={"arabic-language"} /> )
                      </h5>
                      <textarea
                        type="text"
                        name="secondDescription.ar"
                        className="form-control form-outline"
                        {...register("secondDescription.ar")}
                      />
                    </div>
                  </Col>
                  <Col lg={6} xs={12}>
                    <div className="form-group">
                      <h5>
                        <FormattedMessage id={"secondDescription"} /> ({" "}
                        <FormattedMessage id={"english-language"} /> )
                      </h5>
                      <textarea
                        type="text"
                        name="secondDescription.en"
                        className="form-control form-outline"
                        {...register("secondDescription.en")}
                      />
                    </div>
                  </Col>
                </Row>
                <hr />
                <Row>
                  <Col lg={5} xs={12}>
                    <Controller
                      name="videoImage"
                      control={control}
                      rules={{ required: true }}
                      render={({ field: { value, onChange } }) => (
                        <ImageUpdate
                          title="videoImage"
                          value={value}
                          setValue={(value) => onChange(value)}
                        />
                      )}
                    />
                  </Col>
                  <Row />
                  <Col lg={6} xs={12}>
                    <div className="form-group">
                      <h5>
                        <FormattedMessage id={"url"} />
                      </h5>
                      <input
                        type="text"
                        name="url"
                        className="form-control form-outline"
                        {...register("url")}
                      />
                    </div>
                  </Col>
                </Row>
                <hr />
                <div className="form-group">
                  <h5 className="fs-5">
                    <FormattedMessage id={"statics"} />
                  </h5>
                </div>
                <div className="branches form-group">
                  {fields.map((item, index) => (
                    <Row key={index} className="add-multi-component">
                      <Col lg={6} xs={12}>
                        <div className="form-group">
                          <h5>
                            <FormattedMessage id={"title"} /> ({" "}
                            <FormattedMessage id={"arabic-language"} /> )
                          </h5>
                          <input
                            type="text"
                            name="title.ar"
                            className="form-control form-outline"
                            {...register(`statics.${index}.title.ar`)}
                          />
                        </div>
                      </Col>
                      <Col lg={6} xs={12}>
                        <div className="form-group">
                          <h5>
                            <FormattedMessage id={"title"} /> ({" "}
                            <FormattedMessage id={"english-language"} /> )
                          </h5>
                          <input
                            type="text"
                            name="title.en"
                            className="form-control form-outline"
                            {...register(`statics.${index}.title.en`)}
                          />
                        </div>
                      </Col>
                      <Col lg={6} xs={12}>
                        <div className="form-group">
                          <h5>
                            <FormattedMessage id={"number"} /> ({" "}
                            <FormattedMessage id={"arabic-language"} /> )
                          </h5>
                          <input
                            type="text"
                            name="number"
                            className="form-control form-outline"
                            {...register(`statics.${index}.number.ar`)}
                          />
                        </div>
                      </Col>
                      <Col lg={6} xs={12}>
                        <div className="form-group">
                          <h5>
                            <FormattedMessage id={"number"} /> ({" "}
                            <FormattedMessage id={"english-language"} /> )
                          </h5>
                          <input
                            type="text"
                            name="number"
                            className="form-control form-outline"
                            {...register(`statics.${index}.number.en`)}
                          />
                        </div>
                      </Col>
                    </Row>
                  ))}
                </div>
                <hr />
                <div className="form-group">
                  <h5 className="fs-5">
                    <FormattedMessage id={"list"} />
                  </h5>
                </div>
                <div className="branches form-group">
                  {fieldsList.map((item, index) => (
                    <Row key={index} className="add-multi-component">
                      <Col lg={6} xs={12}>
                        <div className="form-group">
                          <h5>
                            <FormattedMessage id={"title"} /> ({" "}
                            <FormattedMessage id="arabic-language" /> )
                          </h5>
                          <input
                            type="text"
                            className="form-control form-outline"
                            {...register(`list.${index}.title.ar`)}
                          />
                        </div>
                      </Col>
                      <Col lg={6} xs={12}>
                        <div className="form-group">
                          <h5>
                            <FormattedMessage id={"title"} /> ({" "}
                            <FormattedMessage id="english-language" /> )
                          </h5>
                          <input
                            type="text"
                            name="title.en"
                            className="form-control form-outline"
                            {...register(`list.${index}.title.en`)}
                          />
                        </div>
                      </Col>
                    </Row>
                  ))}
                </div>
                <SaveChangesButton />
              </Col>
            </form>
          </div>
        </div>
      </div>
    </>
  );
};

export default Overview;
